import { render, staticRenderFns } from "./RegComplete.vue?vue&type=template&id=0cde98c3"
import script from "./RegComplete.vue?vue&type=script&lang=js"
export * from "./RegComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports